module.exports = __webpack_public_path__ + "static/img/rock100.16898907.png";